import { Mail, Phone, MapPin, ShieldCheck } from "lucide-react";
import { TafraLogo } from "@/components/site/Header";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      className="relative py-14"
      style={{
        borderTop: "1px solid var(--border)",
        background: "var(--bg)",
      }}
      data-testid="site-footer"
    >
      <div
        className="absolute top-0 left-0 right-0 h-px"
        style={{
          background:
            "linear-gradient(90deg, transparent, var(--accent-crimson)/40, transparent)",
          opacity: 0.5,
        }}
      />
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <TafraLogo size={44} />
              <div className="leading-none">
                <span
                  className="font-display text-[15px] tracking-[0.28em] font-medium"
                  style={{ color: "var(--text)" }}
                >
                  TAFRA
                </span>
                <span
                  className="block font-display text-[10px] tracking-[0.4em] mt-1"
                  style={{ color: "var(--accent-blue)" }}
                >
                  ENERGY LTD
                </span>
              </div>
            </div>
            <p
              className="mt-5 max-w-sm leading-relaxed"
              style={{ color: "var(--text-muted)" }}
            >
              <span style={{ color: "var(--accent-blue)" }}>Solar EPC</span> ·{" "}
              <span style={{ color: "var(--text)" }}>MEP Engineering</span> ·{" "}
              <span style={{ color: "var(--accent-crimson-hover)" }}>
                Energy Optimization
              </span>
            </p>
            <p className="mt-2 text-sm" style={{ color: "var(--text-faint)" }}>
              Engineering reliable energy systems for homes, businesses, and
              real estate developments.
            </p>
          </div>

          <div className="md:col-span-3">
            <span className="eyebrow">Main office &amp; warehouse</span>
            <div
              className="mt-4 flex items-start gap-3"
              style={{ color: "var(--text-muted)" }}
              data-testid="footer-address"
            >
              <MapPin
                className="w-4 h-4 mt-1"
                style={{ color: "var(--accent-blue)" }}
                strokeWidth={1.6}
              />
              <p className="leading-relaxed">
                Nairobi,
                <br />
                Kenya
              </p>
            </div>
          </div>

          <div className="md:col-span-4">
            <span className="eyebrow eyebrow-crimson">Get in touch</span>
            <div className="mt-4 space-y-3">
              <a
                href="tel:+254725979245"
                data-testid="footer-phone-link"
                className="flex items-center gap-3 transition-colors"
                style={{ color: "var(--text-muted)" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = "var(--accent-blue)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.color = "var(--text-muted)")
                }
              >
                <Phone className="w-4 h-4" strokeWidth={1.6} />
                +254 725 979 245
              </a>
              <a
                href="mailto:contact@tafraenergy.com"
                data-testid="footer-email-link"
                className="flex items-center gap-3 transition-colors break-all"
                style={{ color: "var(--text-muted)" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = "var(--accent-crimson-hover)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.color = "var(--text-muted)")
                }
              >
                <Mail className="w-4 h-4 shrink-0" strokeWidth={1.6} />
                contact@tafraenergy.com
              </a>
            </div>
          </div>
        </div>

        {/* Licensing & certification strip */}
        <div
          className="mt-12 pt-8 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6"
          style={{ borderTop: "1px solid var(--border)" }}
          data-testid="footer-licensing"
        >
          <div className="flex items-center gap-3">
            <ShieldCheck
              className="w-5 h-5 shrink-0"
              style={{ color: "var(--accent-blue)" }}
              strokeWidth={1.6}
            />
            <span
              className="font-mono-spec text-[11px] tracking-[0.28em] uppercase"
              style={{ color: "var(--text-soft)" }}
            >
              Licensed &amp; certified
            </span>
          </div>
          <div className="flex flex-wrap gap-2">
            <span
              className="inline-flex items-center px-3 py-1.5 font-mono-spec text-[11px] tracking-[0.22em] uppercase btn-sharp"
              style={{
                border: "1px solid var(--accent-blue)",
                color: "var(--accent-blue)",
                background: "var(--accent-blue-soft)",
              }}
              data-testid="badge-epra"
            >
              EPRA · Energy &amp; Petroleum Regulatory Authority
            </span>
            <span
              className="inline-flex items-center px-3 py-1.5 font-mono-spec text-[11px] tracking-[0.22em] uppercase btn-sharp"
              style={{
                border: "1px solid var(--accent-crimson)",
                color: "var(--accent-crimson-hover)",
                background: "var(--accent-crimson-soft)",
              }}
              data-testid="badge-nca"
            >
              NCA · National Construction Authority
            </span>
          </div>
        </div>

        <div
          className="mt-8 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3"
          style={{ borderTop: "1px solid var(--border)" }}
        >
          <p
            className="text-xs tracking-wider"
            style={{ color: "var(--text-faint)" }}
          >
            © {year} TAFRA ENERGY LTD. All rights reserved.
          </p>
          <p
            className="text-[11px] uppercase tracking-[0.3em]"
            style={{ color: "var(--text-faint)" }}
          >
            www.tafraenergy.com ·{" "}
            <span style={{ color: "var(--accent-crimson-hover)" }}>
              Launching Soon
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
